import { Observable } from 'rxjs';
import { UpdateCompanyRequest } from '@app/data/dtos/tpv/company-update.dto';

/**
 * Port abstracto para el ciclo de vida de una Company en el TPV (escritura) — §3.
 * Permiso backend: IsAdmin. Estos endpoints NO llevan `Idempotency-Key` obligatoria.
 *
 * `idCompany` es el identificador de la empresa (id_company).
 *
 * NOTA: el ciclo de vida de UNIDADES se movió a `UnitRepository` (multi-unidad §2);
 * las rutas viejas `/companies/<id>/unit/` (singular) fueron ELIMINADAS por backend.
 */
export abstract class CompanyLifecycleRepository {
  /** Edición parcial de la empresa: al menos un bloque (company/address/contact_person/bank). */
  abstract updateCompany(idCompany: string, payload: UpdateCompanyRequest): Observable<void>;

  /** Soft-delete reversible de la empresa. */
  abstract deleteCompany(idCompany: string): Observable<void>;
}
